import { createFileRoute } from "@tanstack/react-router";
import { ReporteriaBuilderPage } from "@/features/reporteria/components/ReporteriaBuilderPage";

/**
 * Ruta `/reporteria` · builder de reportes dinámicos del usuario (S11). El acceso
 * real lo resuelve el backend (política `reporteria.acceso`): si el usuario no
 * tiene ninguna configuración asignada, el catálogo responde 403 y la página
 * muestra un estado "sin acceso" (sin loader para no reventar en el error boundary).
 */
export const Route = createFileRoute("/_authed-tw/reporteria")({
  component: ReporteriaBuilderPage,
});
